/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { blogApi } from './blog.sevices';

export interface BasicResponse {
  success?: boolean;
  counts?: number;
}

export const rtkReducer = {
  [blogApi.reducerPath]: blogApi.reducer,
}

export const rtkMiddleware = [
  blogApi.middleware,
]